"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertHtmlToReact = void 0;
const htmlparser2_1 = require("htmlparser2");
const processNodes_1 = require("./processNodes");
function convertHtmlToReact(html, { decodeEntities, transform, preprocessNodes }) {
    let parsedDocument = (0, htmlparser2_1.parseDocument)(html, {
        decodeEntities: decodeEntities !== null && decodeEntities !== void 0 ? decodeEntities : true
    });
    if (preprocessNodes) {
        parsedDocument = preprocessNodes(parsedDocument);
    }
    return (0, processNodes_1.processNodes)(parsedDocument.childNodes, transform);
}
exports.convertHtmlToReact = convertHtmlToReact;
